

import { Modal,Box,Typography,InputBase,Button,TableContainer,Table,TableHead,TableBody,TableCell,TableRow,Menu,MenuItem ,IconButton} from "@mui/material"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { formStyle } from "./inventoryForm"
import CustomAxios from "../utils/CustomAxios"
import products, { updateCategoryForm, updateConfirmationMessage, updateConfirmationOperation, updateConfirmationPop, updateFormModal, updateProductSubCategory,updateSelectedCategory,updateSubCategoryForm, } from "../redux/products"
import { TranslateText } from "../utils/googletranslator"
import { useEffect } from "react"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Confirmation from "./confirmation";
import { updateSnackBarMessage, updateSnackBarOpen, updateSnackBarSeverity } from "../redux/snackbar"
const AddSubCategory=()=>{

const open=useSelector(state=>state.product.openSubCategory)
const user=useSelector(state=>state.user.id)
const categories=useSelector(state=>state.product.productSubCategory)
const [category,setCategory]=useState("")
const [anchorEl, setAnchorEl] = useState(null);
const selectedcategory = useSelector(state=>state.product.selectedCategory);
const menuOpen = Boolean(anchorEl);
const [message,setMessage]=useState("")
const [operation,setOperation]=useState("")
const [error,setError]=useState()
// const menuOpen=useState(false)
// console.log(open)
const handleClick = (event,item) => {
    setAnchorEl(event.currentTarget);
    // console.log(item,event)
    dispatch(updateSelectedCategory(item))
  };
  const handleClose = () => {
    setAnchorEl(null);
    // dispatch(updateSelectedCategory({}))
  };


const dispatch=useDispatch()

const submitForm=()=>{

    // console.log("/??????????????????",Object.keys(selectedcategory).length<=0)
    if (category?.trim()){
        if (Object.keys(selectedcategory).length<=0){
            CustomAxios.post("create_subcategories/",{name:category,user:user}).then(res=>{
                // console.log("????????????",res)
                if(res.data.message=='Successfully Created'){
                    dispatch(updateProductSubCategory(res.data.subcategories?res.data.subcategories:[]))
                    dispatch(updateCategoryForm(false))
                    setCategory("");
                    dispatch(updateSelectedCategory({}));
                    setError('')
                    dispatch(updateSnackBarMessage("Subcategory Successfully created"))
                    dispatch(updateSnackBarSeverity("success"))
                    dispatch(updateSnackBarOpen(true))
                }
            })
    
        }
        else{
            CustomAxios.put("create_subcategories/",{...selectedcategory,name:category}).then(res=>{
                // console.log("????????????",res)
                if(res.data.message=='Successfully Created'){
                    dispatch(updateProductSubCategory(res.data.subcategories?res.data.subcategories:[]))
                    dispatch(updateCategoryForm(false))
                    setCategory("");
                    dispatch(updateSelectedCategory({}));
                    setError('')
                    dispatch(updateSnackBarMessage("Subcategory Successfully created"))
                    dispatch(updateSnackBarSeverity("success"))
                    dispatch(updateSnackBarOpen(true))
                }
            })
        }
    }
    else(
        setError("Please enter category name")
    )
    
    
}
useEffect(()=>{

    CustomAxios.get('create_subcategories/').then(res=>{
        if(res.data.message=='Successfully Fetched'){
            // console.log("?????????????????????Successfully Fetched",res.data.subcategories)
            dispatch(updateProductSubCategory(res.data.subcategories?res.data.subcategories:[]))
        }}).catch(err=>console.log(err))
},[])
let editCategory=(item,e)=>{
    e.preventDefault()
    setCategory(selectedcategory.name)
    handleClose()
}
const deleteCategory=()=>{
    // console.log(selectedcategory)
    dispatch(updateFormModal("subcategory"))
    dispatch(updateSelectedCategory(selectedcategory))
    dispatch(updateConfirmationPop(true))
    dispatch(updateConfirmationMessage("Are you sure, Do you want to Delete?"))
    dispatch(updateConfirmationOperation ("confirmation"))
    handleClose()
    
   
}

return<><Modal
open={open}
// onClose={handleClose}
aria-labelledby="child-modal-title"
aria-describedby="child-modal-description"
sx={{zIndex:"21 !important"}}
>
<Box sx={{ width: "600px", background: "#fff", left: "50%", top: "50%", position: "absolute", transform: 'translate(-50%, -50%)', padding: "24px", border: "none" ,overflowY:"auto",height:{xs:"95%",sm:"max-content"}}}>

    <Typography sx={{paddingBottom:"15px"}}>Add Sub Category</Typography>
    <Box sx={{display:"flex",flexDirection:"column",gap:"15px"}} >
        <Box sx={{display:"flex",flexDirection:"row",gap:"5px", }}>
        <InputBase value={category}   sx={formStyle.inputBase } onChange={(e)=>{setCategory(e.target.value);console.log(selectedcategory)}}/>
        <Box sx={{alignSelf:"end",display:"flex",gap:"5px"}}>
        <Button variant="contained" sx={{maxWidth:"100px",alignSelf:"end",textTransform:"none",height:"48px" }} onClick={()=>submitForm()}>{Object.keys(selectedcategory).length>0&&category?"Save":"Add"}</Button>
        <Button variant="outlined" sx={{maxWidth:"100px",alignSelf:"end",textTransform:"none",height:"48px" }} onClick={()=>{dispatch(updateSubCategoryForm(false));setCategory("");dispatch(updateSelectedCategory({}));setError("")}}>Cancel</Button>
        
        </Box>
    
        </Box>
        <TranslateText sx={{color:"error.light"}}>{error} </TranslateText>
        <TableContainer>
            <Table>
                <TableHead sx={{ bgcolor: "#E2E8F0" }}>
                    <TableRow>
                        <TableCell sx={{ textAlign: "left" }}><TranslateText>No.</TranslateText> </TableCell>
                        <TableCell sx={{ textAlign: "left" }}><TranslateText>Name</TranslateText> </TableCell>
                        <TableCell sx={{ textAlign: "left" }}><TranslateText>Actions</TranslateText> </TableCell>             
                    
                    </TableRow>
                </TableHead>
                <TableBody>

                {categories.map(item=><TableRow key={item.id}>
                    <TableCell sx={{ textAlign: "left" }}>{item.id}</TableCell> 
                    <TableCell sx={{ textAlign: "left" }}>{item.name}</TableCell> 
                    <TableCell sx={{ textAlign: "left" }}> <IconButton
                            // aria-label="more"
                            aria-label="actions"
                            aria-controls={`actions-menu-${item.id}`}
                            // aria-expanded={menuOpen ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(e)=>handleClick(e,item)}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                        <Menu
                            id={`actions-menu-${selectedcategory?.id}`}
                            MenuListProps={{
                            'aria-labelledby': 'data-array-button',
                            }}
                            anchorEl={anchorEl}
                            open={menuOpen && selectedcategory?.id == item.id}
                            onClose={handleClose}
                        >
                            
                            <MenuItem  onClick={(e)=>editCategory(item.id,e) }>
                                Edit
                            </MenuItem>
                            <MenuItem  onClick={(e)=>deleteCategory(item.id,e)}>
                               Delete
                            </MenuItem>
                           
                        </Menu>
                    </TableCell> 
                </TableRow>)}

                    
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
</Box>

</Modal>
</> 
}

export default AddSubCategory